<template>
	<div class="py-4 w-70">
		<uiInput v-model="rawBonuses" :label="true" placeholder="Начислить" mask="9999" />
		<uiInput v-model="reason" :label="true" placeholder="Причина" />
		<uiButton class="button" @click="save" :loading="loading" :disabled="!valid">
			Начислить {{ bonuses }}
		</uiButton>
	</div>
</template>

<script>
import { API } from '@/config'

export default {
	name: 'UserBonuses',
	props: {
		user: String,
	},
	data() {
		return {
			loading: false,
			rawBonuses: '0',
			reason: '',
		}
	},
	computed: {
		bonuses() {
			return parseInt(this.rawBonuses) || 0
		},
		valid() {
			return this.bonuses && this.reason.length > 3
		},
	},
	methods: {
		async save() {
			if (!this.valid) return
			if (this.loading) return
			this.loading = true

			let payload = {
				id: this.user,
				amount: this.bonuses,
				reason: this.reason,
			}
			let { data } = await this.$http.post(API.USERS.bonuses, payload)
			if (!data || data.err) {
				this.$notify(data.err)
				return (this.loading = false)
			}

			this.$emit('save', data.bonuses)
			this.loading = false
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.button {
	margin-top: 20px;
}
</style>
